import { createStore } from 'vuex'
import layout from 'lg-vue-components/store/modules/layout'

import user from './user'
import { store as usuDelegacaoHist } from '../modules/historicoDelegacao'
import { store as gestaoPerido } from '../modules/gestaoPeriodo'
import { store as relatorios } from '../modules/relatorios'
import { store as justificativa } from '../modules/justificativaOcorrencia'
import { store as grupoUsuario } from '../modules/grupoUsuario'

export default createStore({
   getters: {
      isAuthenticated: (state) => !!state.user,
      StatePosts: (state) => state.posts,
      StateUser: (state) => state.user.user
   },
   modules: {
      ...layout,
      ...user,
      ...usuDelegacaoHist,
      ...gestaoPerido,
      ...relatorios,
      ...justificativa,
      ...grupoUsuario
   }
})
